module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_04_6DC79_1SD_H1Y.0c6efc81.jpg";